export { default } from './FeeRecommendationTitle';
